import {InflowPresentValue, LifestyleSpendingGoal} from "./LifestyleSpendingGoal";

export type PresentValueResponse = {
    presentValue: number;
    goalsPresentValue?: number;
    presentValueByYear?: number[]
    riskAsset: number;
    riskControl: number;
    tripleNetDiscountRate: number;
    grossDiscountRate: number;
    presentValueFundedBySavings?: number;
}

export type LifestylePresentValueResponse = PresentValueResponse & {
    totalAlignedInflowPresentValue: number;
    requiredPortfolioSpendingPresentValue: number;
    portfolioReserveAlignedInflowPresentValue: number;
    portfolioReservePresentValue: number;
    reserveTargetAmount: number;
    presentValueForInsufficientYears: number;
    inflowPresentValues: InflowPresentValue[];
    sufficientYears: number;
    fundedByNonInvestable?: number;
}

export type NonLifestylePresentValueResponse = PresentValueResponse & {
    presentValueFundedByInflows?: number;
    presentValueFundedByPortfolio?: number
    requiredPortfolioRiskAsset?: number
    requiredPortfolioRiskControl?: number
    investableShortfall?: number;
    presentValueFundedByNonInvestables?: number;

}

export type LifestyleAndNonLifestylePresentValueResponse = {
    lifestylePresentValue: LifestylePresentValueResponse | null,
    nonLifestylePresentValue: NonLifestylePresentValueResponse
};

export type NonLSPresentValueRequest = {
    annualFlow: string,
    startDate: string,
    endDate: string,
    riskControlAsset?: string,
    nonPortfolioFunded: number,
}

export type LifestyleAndNonLifestylePresentValueRequest = {
    lifestylePresentValueRequest: LifestyleSpendingGoal["userInputs"] | null;
    nonLifestyleGoal: NonLSPresentValueRequest & { goalId: string } & { isFundedByNonInvestableAssets: boolean };
};

export const emptyPresentValueResponse: PresentValueResponse = {
    presentValue: 0,
    riskAsset: 0,
    riskControl: 100,
    tripleNetDiscountRate: 0,
    grossDiscountRate: 0,
    presentValueFundedBySavings: 0,
}

export const emptyNonLifestylePresentValueResponse: NonLifestylePresentValueResponse = {
    ...emptyPresentValueResponse,
    presentValueFundedByInflows: 0,
    presentValueFundedByPortfolio: 0,
    requiredPortfolioRiskControl: 0,
    requiredPortfolioRiskAsset: 0,
    investableShortfall: 0,
    presentValueFundedByNonInvestables: 0
}

export const emptyLifestylePresentValueResponse: LifestylePresentValueResponse = {
    ...emptyPresentValueResponse,
    totalAlignedInflowPresentValue: 0,
    requiredPortfolioSpendingPresentValue: 0,
    portfolioReserveAlignedInflowPresentValue: 0,
    portfolioReservePresentValue: 0,
    reserveTargetAmount: 0,
    presentValueForInsufficientYears: 0,
    inflowPresentValues: [],
    sufficientYears: 0,
    fundedByNonInvestable: 0
};

export const emptyLifestyleAndNonLifestylePresentValueResponse: LifestyleAndNonLifestylePresentValueResponse = {
    lifestylePresentValue: null,
    nonLifestylePresentValue: emptyNonLifestylePresentValueResponse
};